import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            {/* Hi Everyone, I am <span className="purple">Education </span> */}
            <br/>
            Location <span className="purple"> Dublin, Ireland.</span>
            <br />
            Education <span className="purple">Masters</span> In Data Analytics Dublin Business School 
            <br />
             <span className="purple">Bachelor of Engineering</span>  in Computer Science at Mumbai 
            University.
            <br />
             Below are the skills I truly enjoy working with
            <br />
            {/* Apart from coding, some other activities that I love to do! */}
          </p>
          {/* <ul>
            <li className="about-activity">
              <ImPointRight /> Football
            </li>
            <li className="about-activity">
              <ImPointRight /> DSA
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul> */}

          {/* <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p> */}
          <footer className="blockquote-footer">Arzan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
